import { scaleLog } from 'd3-scale';
import { max, min } from 'd3-array';

export const getBubbleScale = budgets => {
  return scaleLog()
    .domain([min(budgets), max(budgets)])
    .range([5, 35]);
};

const getStripeColorUrl = project => {
  switch (project.priority) {
    case 'CX':
      return 'url(#greenStripes)';
    case 'Data':
      return 'url(#lightBlueStripes)';
    case 'DOI':
      return 'url(#blueStripes)';
    default:
      return 'url(#greenStripes)';
  }
};
const getColor = project => {
  switch (project.priority) {
    case 'CX':
      return '#04b0a8';
    case 'Data':
      return '#00abe6';
    case 'DOI':
      return '#0a7cb9';
    default:
      return '#04b0a8';
  }
};

export const getBubbleColor = project => {
  return !project.budget || project.budget === 0
    ? getStripeColorUrl(project)
    : getColor(project);
};

export const getBubbleHexColor = project => {
  return getColor(project);
};

export const formatNumber = n => {
  if (!n || n === 0) return 'Budget not specified';
  return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};



// WEBPACK FOOTER //
// ./src/modules/bubbleHelper.js